.container {
  width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
}

.title {
  font-size: 40px;
  line-height: 48px;
  font-weight: 900;
  margin-bottom: 24px;
  margin-top: -200px;
}

.input {
  margin-bottom: 16px;
  color: black;
}

.label {
  color: black;
  font-size: 15px;
  line-height: 24px;
  font-weight: 500;
  margin-bottom: 6px;
}

.authFormCont {
  width: 352px;
  margin: auto;
}

.input:-webkit-autofill,
.input:-webkit-autofill:hover,
.input:-webkit-autofill:focus,
.input:-webkit-autofill:active,
.input {
  border: none;
  -webkit-box-shadow: 0 0 0 30px #eeeeee inset !important;
  margin-bottom: 0;
}

.inputButton {
  border-radius: 44px;
  height: 56px;
  border: none;
  background-color: black;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  padding: 16px;
  color: white;
}

.inputButton:focus {
  outline: 0 !important;
  box-shadow: none !important;
}

.positionBottom {
  /* position: absolute;
  bottom: 36px; */
}

/* The sphere's demo hand: SignInSphere sets the variables every frame;
   10px is the cursor image's hotspot (CURSOR_HOTSPOT). */
.hand {
  transform-origin: 10px 10px;
  opacity: var(--hand-show, 0);
  transform: translate(var(--hand-x, 0), var(--hand-y, 0))
    scale(calc(0.5 + 0.5 * var(--hand-show, 0)));
}

/* Fades the sphere behind the Studio banner. Tune the variables:
   --fade-center   sphere opacity behind the text (0-1)
   --fade-outside  sphere opacity at the edges (0-1)
   --fade-start / --fade-end  where the fade begins and ends, as a share of
                   the ellipse; further apart = smoother transition
   --fade-size     the ellipse's width and height
   The 9 stops follow a smoothstep curve so the fade has no visible edges. */
.sphereFade {
  --fade-center: 0.05;
  --fade-outside: 1;
  --fade-start: 40%;
  --fade-end: 100%;
  --fade-size: 50% 30%;
  mask-image: radial-gradient(
    ellipse var(--fade-size) at center,
    rgb(0 0 0 / var(--fade-center)) var(--fade-start),
    rgb(
        0 0 0 /
          calc(
            var(--fade-center) + (var(--fade-outside) - var(--fade-center)) *
              0.043
          )
      )
      calc(var(--fade-start) + (var(--fade-end) - var(--fade-start)) * 0.125),
    rgb(
        0 0 0 /
          calc(
            var(--fade-center) + (var(--fade-outside) - var(--fade-center)) *
              0.156
          )
      )
      calc(var(--fade-start) + (var(--fade-end) - var(--fade-start)) * 0.25),
    rgb(
        0 0 0 /
          calc(
            var(--fade-center) + (var(--fade-outside) - var(--fade-center)) *
              0.316
          )
      )
      calc(var(--fade-start) + (var(--fade-end) - var(--fade-start)) * 0.375),
    rgb(
        0 0 0 /
          calc(
            var(--fade-center) + (var(--fade-outside) - var(--fade-center)) *
              0.5
          )
      )
      calc(var(--fade-start) + (var(--fade-end) - var(--fade-start)) * 0.5),
    rgb(
        0 0 0 /
          calc(
            var(--fade-center) + (var(--fade-outside) - var(--fade-center)) *
              0.684
          )
      )
      calc(var(--fade-start) + (var(--fade-end) - var(--fade-start)) * 0.625),
    rgb(
        0 0 0 /
          calc(
            var(--fade-center) + (var(--fade-outside) - var(--fade-center)) *
              0.844
          )
      )
      calc(var(--fade-start) + (var(--fade-end) - var(--fade-start)) * 0.75),
    rgb(
        0 0 0 /
          calc(
            var(--fade-center) + (var(--fade-outside) - var(--fade-center)) *
              0.957
          )
      )
      calc(var(--fade-start) + (var(--fade-end) - var(--fade-start)) * 0.875),
    rgb(0 0 0 / var(--fade-outside)) var(--fade-end)
  );
}
